import { Link, useParams } from "react-router-dom";
import { Icon } from "@/lib/icons";
import { useApp } from "@/hooks/use-app-context";
import { useValidationGate } from "../useValidationGate";

export function ValidationGateBanner({ className }: { className?: string }) {
  const { t } = useApp();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || "fr";
  const gate = useValidationGate();

  if (!gate.isWarning) return null;

  return (
    <div
      className={`flex items-start gap-3 rounded-lg border border-warning/25 bg-warning/[0.06] px-4 py-3 ${className ?? ""}`}
    >
      <Icon name="alertTriangle" className="mt-0.5 size-4 shrink-0 text-warning" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-foreground">{t.validationGateWarningTitle}</p>
        <p className="mt-1 text-sm leading-6 text-muted-foreground">
          {t.validationGateWarningDesc.replace("{remaining}", String(gate.remainingBeforeBlock))}
        </p>
        <div className="mt-1 flex flex-wrap gap-x-4">
          <Link
            to={`/${currentLang}/validate-audio`}
            className="inline-flex min-h-11 items-center text-sm font-medium text-brand hover:underline"
          >
            {t.validationGateGoValidateAudio}
          </Link>
          <Link
            to={`/${currentLang}/validate-transcription`}
            className="inline-flex min-h-11 items-center text-sm font-medium text-brand hover:underline"
          >
            {t.validationGateGoValidateTranscription}
          </Link>
        </div>
      </div>
    </div>
  );
}
